import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-single-select-dropdown2',
  templateUrl: './single-select-dropdown.component.html',
  styleUrls: ['./single-select-dropdown.component.scss'],
  standalone: false
})
export class SingleSelectDropdownComponent implements OnInit {
  @Input() clicked: any;
  @Input() items: any[];
  @Input() label: string;
  @Input() showMore: boolean;
  @Input() requireApply: boolean;
  @Input() searchFilterActive: boolean | null;
  @Input() borderRadius: string = '0.8rem';
  @Input() alternateLook: boolean = false;
  @Input() selectedItem: any;
  @Input() id: string = '';
  @Input() disabled: boolean = false;
  @Input() textColor: string | null = null;
  @Input() maxDisplayItems: number = 10;
  @Input() displayProperty: string | null = null;
  @Input() valueProperty: string | null = null;

  @Output() shareSelectedItem = new EventEmitter();
  @Output() applyFilterEmitter = new EventEmitter();
  @Output() filterValue = new EventEmitter();

  currentSelected: any;
  seletedLabel: any;
  public searchValue: any;

  constructor() { }

  ngOnInit(): void {
  }

  applySearchFilter(value: any) {
    this.filterValue.emit(value);
  }

ngOnChanges(changes: SimpleChanges) {
  if (changes['selectedItem']) {
    this.currentSelected = this.selectedItem;
    this.seletedLabel = this.currentSelected ? this.getDisplayValue(this.currentSelected) : '';
  }
}

getDisplayValue(item: any): string {
  return (this.displayProperty ? item?.[this.displayProperty] : item?.name) ?? '';
}

getItemValue(item: any): any {
  return this.valueProperty ? item?.[this.valueProperty] : item?.id;
}

getSelectedValue(value: any) {
  this.currentSelected = this.items.find(x => this.getItemValue(x) === value);

  this.seletedLabel = this.currentSelected ? this.getDisplayValue(this.currentSelected) : '';

  this.shareSelectedItem.emit(this.currentSelected);
  this.applyFilter();
}


  applyFilter() {
    this.applyFilterEmitter.emit();
  }
}
